export {default as dispatch} from "./dispatch.js";



// WEBPACK FOOTER //
// C:/Dropbox/www/amcharts4dev/node_modules/d3-dispatch/src/index.js